export enum BaseDataKvType {
  RESIDENT_NUMBER = 'residentNumber',
  GENDER = 'gender',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  ROOM = 'room',
  STATION = 'station',
  LIVING_AREA = 'livingArea',
  CARE_LEVEL = 'careLevel',
  LAST_APPLICATION_DATE = 'lastApplicationDate',
  LAST_ASSESSMENT_DATE = 'lastAssessmentDate',
  HEALTH_INSURANCE_COMPANY = 'healthInsuranceCompany',
  HEALTH_INSURANCE_NUMBER = 'healthInsuranceNumber',
  PRESCRIPTION_FEE_UNTIL = 'prescriptionFeeUntil',
  NOTES = 'notes',
}
